import { render, staticRenderFns } from "./GetStartedModal.vue?vue&type=template&id=be1a3bec&scoped=true&"
import script from "./GetStartedModal.vue?vue&type=script&lang=js&"
export * from "./GetStartedModal.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedModal.vue?vue&type=style&index=0&id=be1a3bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1a3bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VContainer,VForm,VLayout,VProgressCircular,VTextField})
